import { render, staticRenderFns } from "./workerCertificateProHire.vue?vue&type=template&id=d03db354&"
import script from "./workerCertificateProHire.vue?vue&type=script&lang=js&"
export * from "./workerCertificateProHire.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports